import React, { useState } from 'react';
import '../styles/Export.css';

const countries = [
  {
    code: 'BR',
    flag: '🇧🇷',
    name: 'Brazil',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14898801.993!2d-54.0!3d-14.0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9c59c7ebcc28cf%3A0x295a1506f2293e63!2sBrazil!5e0!3m2!1sen!2sin!4v1700000000000',
  },
  {
    code: 'IT',
    flag: '🇮🇹',
    name: 'Italy',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5969847.123!2d12.5!3d42.5!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a9f3e4bd5f2d3b%3A0x1eb82b4acaafed6f!2sItaly!5e0!3m2!1sen!2sin!4v1700000000000',
  },
  {
    code: 'ID',
    flag: '🇮🇩',
    name: 'Indonesia',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d16198910.123!2d117.0!3d-2.5!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2c4c07d7796a5aa7%3A0xa7bfd1b5d2f7b0c1!2sIndonesia!5e0!3m2!1sen!2sin!4v1700000000000',
  },
  {
    code: 'CN',
    flag: '🇨🇳',
    name: 'China',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15069961.123!2d104.0!3d35.0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x310c702439800e41%3A0xd75b9a4cefed8a4!2sChina!5e0!3m2!1sen!2sin!4v1700000000000',
  },
  {
    code: 'NP',
    flag: '🇳🇵',
    name: 'Nepal',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3570089.123!2d84.0!3d28.0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3995e8c77d296ebb%3A0x99b3b4ba1bfd7297!2sNepal!5e0!3m2!1sen!2sin!4v1700000000000',
  },
  {
    code: 'VN',
    flag: '🇻🇳',
    name: 'Vietnam',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7859291.123!2d107.0!3d16.0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31157a4d736b4e39%3A0xa2ef25ba66d1d2a1!2sVietnam!5e0!3m2!1sen!2sin!4v1700000000000',
  },
  {
    code: '🌍',
    flag: '🌍',
    name: 'And many other countries',
    mapUrl: null,
  },
];

function Export() {
  const [selectedCountry, setSelectedCountry] = useState(null);

  const handleCardClick = (country) => {
    if (!country.mapUrl) return;
    setSelectedCountry(country);
    setTimeout(() => {
      document.getElementById('country-map-view')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleClose = () => {
    setSelectedCountry(null);
  };

  return (
    <div className="export-page">

      {/* World Map Section */}
      <section className="export-map-section">
        <h2 className="section-title">OUR GLOBAL PRESENCE</h2>
        <p className="section-subtitle">
          Sachin Kath Industries supplies products across India and international markets.
        </p>
        <div className="map-container">
          <img
            src="/map.png"
            alt="Global Presence Map"
            className="world-map-img"
          />
        </div>
      </section>

      {/* Global Presence Section */}
      <section className="global-presence-section">
        <div className="global-presence-inner">
          <h2 className="gp-title">Global Presence</h2>
          <p className="gp-description">
            Sachin Kath Industries supplies products across India and international markets, including:
          </p>

          <div className="country-grid">
            {countries.map((c, i) => (
              <div
                className={`country-card ${c.mapUrl ? 'clickable' : 'no-click'} ${selectedCountry?.code === c.code ? 'active' : ''}`}
                key={i}
                onClick={() => handleCardClick(c)}
                title={c.mapUrl ? `View ${c.name} on map` : ''}
              >
                <span className="country-flag">{c.flag}</span>
                <span className="country-name">{c.name}</span>
                {c.mapUrl && <span className="map-icon">🗺️</span>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Country Map Popup */}
      {selectedCountry && (
        <section className="country-map-section" id="country-map-view">
          <div className="country-map-inner">
            <div className="country-map-header">
              <h3>
                <span>{selectedCountry.flag}</span>
                {selectedCountry.name}
              </h3>
              <button className="close-btn" onClick={handleClose}>✕ Close</button>
            </div>
            <div className="country-map-frame">
              <iframe
                src={selectedCountry.mapUrl}
                title={`Map of ${selectedCountry.name}`}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </section>
      )}

    </div>
  );
}

export default Export;